import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "400",
  "slug": "what-is-the-jet-stream",
  "title": "What Is the Jet Stream? The High-Altitude River of Wind That Shapes Your Weather",
  "excerpt": "Ribbons of fast-moving air, miles above your head, steer storms and decide whether your flight is early or late. Meet the jet stream.",
  "date": "2026-06-10",
  "category": "Education",
  "image": "https://images.unsplash.com/photo-1501630834273-4b5604d2ee31?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxjbG91ZHMlMjBza3klMjBhdG1vc3BoZXJlfGVufDF8MHx8fDE3ODEwNzkyMjF8MA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "6 min",
  "author": "EarthGuessr Team",
  "tldr": "The jet stream is a band of fast-moving air high in the atmosphere, often blowing well over 160 km/h, that flows west to east, steers weather systems below it, and makes eastbound flights faster than westbound ones.",
  "content": [
    {
      "type": "paragraph",
      "text": "Far above the clouds, faster than any storm you will ever feel on the ground, rivers of wind snake around the planet from west to east. They are called jet streams, and although you cannot see or feel them directly, they help decide whether your weekend is sunny or soaked, and whether your flight lands early or fights a headwind the whole way."
    },
    {
      "type": "heading",
      "text": "Where the Jet Stream Lives"
    },
    {
      "type": "paragraph",
      "text": "Jet streams flow near the top of the troposphere, roughly 9 to 12 kilometres up, which is right around the cruising altitude of a passenger jet. That is no coincidence in terms of how they were discovered: it was high-altitude pilots, especially during the Second World War, who first noticed they were being shoved along by ferocious winds that no one on the ground had ever measured."
    },
    {
      "type": "heading",
      "text": "What Creates It"
    },
    {
      "type": "paragraph",
      "text": "The jet stream is born from contrast. Where cold polar air meets warmer air from the tropics, the sharp temperature difference creates a steep pressure gradient high in the atmosphere. The planet's rotation then bends that flowing air, through the Coriolis effect, into a fast current running roughly west to east. Each hemisphere typically has two of these: a stronger polar jet near the boundary of the cold polar air, and a weaker subtropical jet closer to the tropics."
    },
    {
      "type": "heading",
      "text": "How It Shapes the Weather Below"
    },
    {
      "type": "paragraph",
      "text": "The jet stream acts like a conveyor belt for weather systems, steering storms and pushing fronts across continents. But it does not run in a straight line. It meanders north and south in great waves, and those waves matter enormously. When a wave dips south, it can drag cold air far down into normally mild regions; when it bulges north, it can pull warm air up and leave a region baking under a stubborn high-pressure dome. When the pattern stalls, the same weather, hot, cold, wet, or dry, can linger for days."
    },
    {
      "type": "heading",
      "text": "Why Your Flight Time Depends on It"
    },
    {
      "type": "paragraph",
      "text": "Because the jet stream blows from west to east, an aircraft flying eastbound can ride it like a tailwind and arrive noticeably early, while a westbound flight has to push against it and takes longer. This is why a trip from North America to Europe is often shorter than the return leg. Airlines plan routes carefully to catch a favourable jet stream and dodge an unfavourable one, saving both time and fuel."
    },
    {
      "type": "heading",
      "text": "The Jet Stream and a Changing Climate"
    },
    {
      "type": "paragraph",
      "text": "Because the jet stream is powered by the temperature contrast between the poles and the tropics, scientists are actively studying how a warming Arctic might affect it. One area of ongoing research asks whether a weaker contrast could make the jet stream wavier and slower to move on, which would allow weather extremes to stick around longer. It is a genuinely open question, and a good example of how a single feature of the atmosphere connects to the whole climate system."
    },
    {
      "type": "paragraph",
      "text": "The jet stream is a reminder that the planet is a single connected machine, where a temperature difference thousands of kilometres away can shape the sky over your house. If watching the weather makes you want to look at the world from above, EarthGuessr is a fun place to start exploring it."
    }
  ]
};
